import {useContext, useState} from 'react'
import {Link} from 'react-router-dom'
import EntityPerformanceChartModal from '../../../../components/EntityPerformanceChartModal/EntityPerformanceChartModal'
import ProfitTrendModal from '../modals/ProfitTrendModal'
import {BrandReportContext} from '../../context'
import {MIN_DATE_RANGE} from '../../utils'

const BrandReportRow = ({row}: any) => {
  const [showChartModal, setShowChartModal] = useState(false)
  const [showProfitTrendModal, setShowProfitTrendModal] = useState(false)

  const {
    entityPerformanceChartData,
    isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
    // Profit Trend Modal Data
    profitTrendChartData,
    profitTrendKpiData,
    profitTrendWeeklyBreakdownData,
    isProfitTrendDataLoading,
    onProfitTrendIdChange,
  } = useContext(BrandReportContext)

  return (
    <>
      <tr>
        <td>{row.brandName}</td>
        <td>{row.purchaserName || '-'}</td>
        <Link
          to={{
            pathname: '/analytics/profitability/profitability-report',
            search: `?view=order-report&brand=${row.brandId}`,
          }}
          target='_blank'
          className='text-dark text-decoration-underline'
        >
          {row.orders}
        </Link>
        <td>{row.totalCost}</td>
        <td>{row.totalSale}</td>
        <td>{row.totalProfit}</td>
        <td>
          <span
            onClick={() => setShowProfitTrendModal(true)}
            className='text-hover-primary cursor-pointer text-decoration-underline'
            style={{cursor: 'pointer'}}
          >
            {row.totalProfitPercentage}
          </span>
        </td>
        <td>{row.contributedProfitPercentage}</td>
        <td>
          <div className='d-flex justify-content-end'>
            <span
              onClick={() => setShowChartModal(true)}
              className='w-30px h-30px d-flex justify-content-center align-items-center text-primary cursor-pointer'
            >
              <i className='fas fa-chart-line text-primary'></i>
            </span>
          </div>
        </td>
      </tr>
      {showChartModal && (
        <EntityPerformanceChartModal
          onClose={() => setShowChartModal(false)}
          entityId={row.brandId}
          entityPerformanceChartData={entityPerformanceChartData}
          entityName={`Profitability Report - ${row.brandName}`}
          onEntityPerformanceChartIdChange={onEntityPerformanceChartIdChange}
          onEntityPerformanceChartViewChange={onEntityPerformanceChartViewChange}
          onEntityPerformanceChartDateRangeChange={onEntityPerformanceChartDateRangeChange}
          entityPerformanceChartFilters={entityPerformanceChartFilters}
          isEntityPerformanceChartDataLoading={isEntityPerformanceChartDataLoading}
          startDate={MIN_DATE_RANGE}
        />
      )}

      {showProfitTrendModal && (
        <ProfitTrendModal
          onClose={() => setShowProfitTrendModal(false)}
          entityId={row.brandId}
          entityName={row.brandName}
          onProfitTrendIdChange={onProfitTrendIdChange}
          isProfitTrendDataLoading={isProfitTrendDataLoading}
          profitTrendChartData={profitTrendChartData}
          kpiData={profitTrendKpiData}
          weeklyBreakdownData={profitTrendWeeklyBreakdownData}
        />
      )}
    </>
  )
}
export default BrandReportRow
